module.exports = __webpack_public_path__ + "img/logo-horizontal-color-nmls.adc03754.png";